
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news-exhibitions/[slug]",
      function () {
        return require("private-next-pages/news-exhibitions/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news-exhibitions/[slug]"])
      });
    }
  